import React from "react";
import "./Something_Big_Coming.css";
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";

function Something_Big_Coming() {
  return (
    <section className="Something_Big_Coming">
      <div className="custom_container">

        <Homepage_common_heading
          headingText={"Something Big Is Coming…"}
          headingDescText={
            "Make your brand visible, memorable, and powerful."
          }
        />

        {/* Grid Section */}
        <div className="row sbc_grid">

          {/* Left Column */}
          <div className="col-lg-3 col-md-3 col-3 sbc_col px-1">
            <div className="sbc_card sbc_card_2">
              <img src="/assets/Images/Home/Something_Big_Coming/img_1.png" alt="trophy" />
            </div>
            <div className="sbc_card sbc_card_1">
              <img src="/assets/Images/Home/Something_Big_Coming/img_2.png" alt="wallet" />
            </div>
          </div>

          {/* Center Column */}
          <div className="col-lg-6 col-md-6 col-6 sbc_col center_col px-1">
            <div className="sbc_card big_card">
              <img src="/assets/Images/Home/Something_Big_Coming/img_3.png" alt="hoodie" />
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-3 col-md-3 col-3 sbc_col px-1">
            <div className="sbc_card sbc_card_1">
              <img src="/assets/Images/Home/Something_Big_Coming/img_4.png" alt="poster" />
            </div>
            <div className="sbc_card  sbc_card_2">
              <img src="/assets/Images/Home/Something_Big_Coming/img_5.png" alt="bag" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Something_Big_Coming;